<soph-header-sophia />

<div class="container">
  <div class="title">
    <h1>¡Bienvenido a Sophia, tu <span>asistente médico!</span></h1>
    <p>Para comenzar, por favor selecciona el centro médico al que deseas acceder</p>
  </div>

  <div class="filters">
    <div class="searcher">
      <soph-input-search-form-field
        [control]="searchControl"
        placeholder="Busca el nombre de tu centro médico"
      />
    </div>

    <div class="selectors">
      <soph-select-form-field
        label="Empresa"
        [control]="companiesControl"
        subscriptSizing="dynamic"
        valueProperty="idEmpresa"
        displayProperty="nombre"
        [options]="companyOptions()"
      />

      @if(isAssistant()) {
      <soph-select-form-field
        label="Médico"
        [control]="doctorControl"
        subscriptSizing="dynamic"
        valueProperty="idMedico"
        displayProperty="nombreCompleto"
        [options]="doctorOptions()"
      />
      }
    </div>
  </div>

  @if(isLoading()) {
  <div class="loading-container">
    <soph-modal-spinner />
  </div>

  } @else {
  <div class="medical-centers">
    <div class="list">
      <div [class]="'cards' + (filteredMedicalCenters().length === 0 ? ' empty' : '')">
        @for (medicalCenter of filteredMedicalCenters(); track $index) {
        <mat-card (click)="goToScheduleAppointment(medicalCenter)">
          <div class="icon">
            <mat-icon svgIcon="hospital"></mat-icon>
          </div>
          <mat-card-header>
            <mat-card-title>{{ medicalCenter.nombre }}</mat-card-title>
          </mat-card-header>
        </mat-card>
        } @empty {
        <p>No se encontraron centros médicos</p>
        }
      </div>
    </div>
  </div>
  }
</div>
